import React, { useContext, useEffect } from 'react'
// import Typography from 'typography'
// import { HangUpIcon, MicIcon, MicOffIcon, PauseIcon, VolumeUpIcon } from 'svg-icons'
// import DisplayName from 'display-name'

// import { MyPhoneContactProvider, ScreenSizeProvider, LeaveProvider, LeaveConsumer, LeaveProviderContext, FeatureEventsProvider } from 'providers'
// import { ThemeProvider } from 'providers'
// import { WebPhone } from 'web-phone'

import ReactDOM from 'react-dom'

import { FeatureEventsContext, MyPhoneContactContext, ThemeContext } from 'providers/src'
import { CallState, PdcCallContext } from 'pdc-calls'
import Typography from 'typography'
import Timer from 'timer'
import { HangUpIcon, MicIcon, MicOffIcon, PauseIcon, PhoneRingingIcon, VolumeUpIcon } from 'svg-icons'
import { makeStyles } from '@material-ui/core'
import Button from 'button-mui'

/**
 * @param {object} theme
 */
const styles = theme => ({
    activeCall: {
        backgroundColor: theme.palette.text.primary,
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: 46,
        minHeight: 46,
        borderRadius: 0,
        justifyContent: 'center',
        columnGap: 10,
        color: 'white',
        paddingLeft: 12,
        paddingRight: 12,
        marginRight: 3,
        cursor: 'pointer',
        '& > .call-info': {
            display: 'flex',
            flexDirection: 'column',
            rowGap: 1,
            '& > .name-and-duration': {
                display: 'flex',
                alignItems: 'center',
                columnGap: 8,
                '& > p': {
                    maxWidth: 110,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                }
            },
            '& > .participants': {
                display: 'flex',
                alignItems: 'center',
                columnGap: 10,
                '& > div': {
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: 5,
                    '& > svg': {
                        fontSize: 18,
                        color: theme.palette.secondary.light
                    }
                }
            }
        },
        '& > .call-actions': {
            display: 'flex',
            alignItems: 'center',
            columnGap: 10,
            '& > button': {
                width: 32,
                minWidth: 32,
                height: 32,
                minHeight: 32,
                borderRadius: '50%',
                border: 'none',
                cursor: 'pointer',
                position: 'relative',
                '& > svg': {
                    fontSize: 18,
                    color: 'white',
                    position: 'absolute',
                    top: '8px',
                    left: '8px'
                },
                '&.mute-button': {
                    backgroundColor: theme.palette.primary.main,
                    '&.muted': {
                        backgroundColor: theme.palette.secondary.main
                    }
                },
                '&.hangup-button': {
                    backgroundColor: theme.palette.error.main
                }
            }
        }
    }
})

/***/
/**
 *
 */
export const PictureInPicture = (props): JSX.Element | null => {
    const [pictureInPictureWindow, setPictureInPictureWindow] = React.useState(null)
    const [tabHidden, setTabHidden] = React.useState(false)
    const [userIntereactedWithPage, setUserIntereactedWithPage] = React.useState(false)
    const [displayName, setDisplayName] = React.useState('')

    const contactContext = React.useContext(MyPhoneContactContext)

    const featureEventsContext = useContext(FeatureEventsContext)
    const callContext: any = useContext(PdcCallContext)
    const theme: any = useContext(ThemeContext)
    const useStyles = makeStyles(styles)
    const classes = useStyles()

    const updateDisplayName = async (value) => {
        if (value) {
            contactContext.getDisplayName(value).then(
                contextDisplayName => {
                    setDisplayName(contextDisplayName)
                }
            ).catch(err => console.error(err))
        }
    }

    const getName = (call): JSX.Element => {
        if (!call) {
            return <></>
        }
        const participants = call.participants

        const phoneNumber = participants[0].phoneNumber
        if (phoneNumber) updateDisplayName(phoneNumber)
        if (participants.length > 1) return <>{participants.length} CALLERS</>
        if (participants.length) return <>{ displayName || phoneNumber}</>
        return <>NO CALLER ID</>
    }

    async function pictureInPictureMode (pipInfo) {
        if ('documentPictureInPicture' in window && (pictureInPictureWindow || tabHidden)) {
            const element = renderPIP(pipInfo)

            if (!element) {
                return
            }

            const pipOptions = {
                // initialAspectRatio: element.clientWidth / element.clientHeight,
                initialAspectRatio: element.clientWidth / element.clientHeight,
                lockAspectRatio: true,
                copyStyleSheets: true,
                width: 240,
                disallowReturnToOpener: true,
                height: 50
            }
            let pipWindow = pictureInPictureWindow

            if (!pipWindow && userIntereactedWithPage) {
                try {
                    pipWindow = await window.documentPictureInPicture.requestWindow(pipOptions)
                } catch (error) {
                    console.warn('Error requesting Picture-in-Picture window:', error)
                    return // we get user intereaction with page error sometimes hard to predict with chrome changes, so we just return
                }
                pipWindow.addEventListener('pagehide', (event) => {
                    setPictureInPictureWindow(null)
                })
                setPictureInPictureWindow(pipWindow)
                // setTimeout(() => { pictureInPictureMode(pipInfo) }, 200) // weird issue where stylesheets are not applied until next render, maybe race conditon
            }
            if (!pipWindow) return
            setStyleSheetsToPIPWindow(pipWindow)
            // Add element to the PiP window.
            let container = pipWindow?.document.querySelector('#PipContatiner')
            if (!container) {
                container = document.createElement('div')
                container.setAttribute('id', 'PipContatiner')
                pipWindow.document.body.appendChild(container)
            } else {
                container.replaceWith(container)
            }

            // Render the React component into the new window
            ReactDOM.render(element, container)
        }
    }

    const hangUp = () => {
        featureEventsContext.pushEvent({ appName: 'softphone', key: 'pip-active-call-hang-up-button-click' })
        callContext.hangupById(callContext.currentCall.callId || callContext.incomingCalls[0].callId, true)
    }
    const answer = () => {
        callContext.answerById(callContext.incomingCalls[0].callId)
    }

    useEffect(() => {
        // let timeoutID
        document.addEventListener('visibilitychange', function () {
            setTabHidden(document.hidden)
        })
        document.body.addEventListener('click', () => {
            setUserIntereactedWithPage(true)
            // seems to be a 5 second window since last interaction for pip, commented out for now as it seems to not happen on newer chrome

            // clearTimeout(timeoutID)
            // timeoutID = setTimeout(() => {
            //     setUserIntereactedWithPage(false)
            //     console.log('time limit reached')
            // }, 4999)
        })
    }, [])
    useEffect(() => {
        const currentCall = callContext.currentCall
        const incomingCalls = callContext.incomingCalls
        const pipInfo = {
            infoLabel: null,
            actions: [
            ]
        }
        if (!(currentCall || incomingCalls?.length)) {
            if (pictureInPictureWindow) {
                // pipInfo.infoLabel = (pipListeningForIncomingCallLabel())
                // todo commented out for now to evaluate
                pictureInPictureWindow.close()
            }
        } else if (callContext.incomingCalls?.length > 0) {
            pipInfo.infoLabel = pipIncomingCallLabel(incomingCalls[0])

            // pipInfo.actions.push({ label: 'answer', onClick: answer })
        } else {
            pipInfo.infoLabel = pipCurrentCallLabel(currentCall)
        }
        if (pipInfo.infoLabel) {
            pictureInPictureMode(pipInfo)
        }

        console.log('pipInfo', pipInfo)
    }, [callContext.currentCall, callContext.incomingCalls, tabHidden])

    // commented out for now as it seems to not be needed on newer chrome
    // useEffect(() => {
    //     if (!tabHidden) {
    //         // setUserIntereactedWithPage(false)
    //     }
    // }, [tabHidden])

    useEffect(() => {
        if (pictureInPictureWindow && userIntereactedWithPage) {
            pictureInPictureWindow.close()
            setPictureInPictureWindow(null)
        }
    }, [userIntereactedWithPage])

    const pipCurrentCallLabel = (currentCall) => {
        const MuteIcon = callContext.isMutedLocal ? MicOffIcon : MicIcon
        const onHoldCount = callContext.sessions.filter(s => s.isOnHold).length
        const activeCallsCount = callContext.sessions.length - onHoldCount
        return <> <div className={`${classes.activeCall} active-call`} data-testid='pip-active-call' >
            <div className='call-info' onClick={() => {
                window.focus()
            }}>
                <div className='name-and-duration'>
                    <Typography variant='body2'>{getName(currentCall)}</Typography>
                    {currentCall.callState === CallState.ACTIVE
                        ? <Typography variant='body2'><Timer startTime={currentCall.callStartTime}/></Typography>
                        : null
                    }
                </div>
                <div className='participants'>
                    <div><VolumeUpIcon/><Typography variant='subtitle2'>{activeCallsCount}</Typography></div>
                    <div><PauseIcon/><Typography variant='subtitle2'>{onHoldCount.toString()}</Typography></div>
                </div>
            </div>
            <div className='call-actions'>
                <button data-testid='pip-mute-button' className={`mute-button ${callContext.isMutedLocal ? 'muted' : ''}`} onClick={() => { callContext.muteLocal(!callContext.isMutedLocal) }}><MuteIcon/></button>
                <button data-testid='pip-hangup-button' className='hangup-button' onClick={hangUp}><HangUpIcon/></button>
            </div>
        </div>
        </>
    }

    function setStyleSheetsToPIPWindow (pipWindow) {
        Array.from(document.styleSheets).forEach((styleSheet) => { // copy stylesheets into pip window
            if (!styleSheet) return

            try {
                if (!styleSheet.cssRules) throw new Error('cssRules not accessible')

                const cssRules = [...styleSheet.cssRules].map((rule) => rule.cssText).join('')
                const style = document.createElement('style')

                style.textContent = cssRules
                pipWindow.document.head.appendChild(style)
            } catch (e) {
                const link = document.createElement('link')

                link.rel = 'stylesheet'
                link.type = styleSheet.type
                link.media = styleSheet.media
                link.href = styleSheet.href
                // pipWindow.document.body.style.backgroundColor = 'black !important;'
                const style = document.createElement('style')
                style.innerHTML = `
                    ::-webkit-scrollbar-track {
                    background-color: ${theme.palette.text.primary};
                    }

                    ::-webkit-scrollbar-thumb {
                    background-color: ${theme.palette.text.primary};
                    }

                    body {
                        background-color: ${theme.palette.text.primary} !important;
                        color: white;

                    }

                    html {
                    overflow: hidden;
                    }
                `
                pipWindow.document.head.appendChild(style)
                pipWindow.document.head.appendChild(link)
            }
        })
    }

    const pipIncomingCallLabel = (currentCall) => {
        return <> <div className={`${classes.activeCall} active-call`} data-testid='pip-active-call' >
            <div className='call-info' onClick={() => {
                window.focus()
            }}>
                <div className='name-and-duration'>
                    <Typography variant='body2'>{getName(currentCall)}</Typography>
                </div>
            </div>
            <div className='call-actions'>
                <button data-testid='pip-answer-button' className='mute-button ' onClick={answer}><PhoneRingingIcon /></button>
                <button data-testid='pip-hangup-button' className='hangup-button' onClick={hangUp}><HangUpIcon/></button>
            </div>
        </div>
        </>
    }

    const renderPIP = (pipInfo) => {
        return <div>
            {pipInfo.infoLabel}
            {pipInfo.actions.map((action) => {
                return <Button key={action.label} style={{ width: 500, height: 200, background: 'red' }}onClick={() => { action.onClick() }}> {action.label}</Button>
            })}
        </div>
    }

    return (
    // eslint-disable-next-line react/prop-types
        <>{props.children}</>
    )
}

export default PictureInPicture
